import { Input } from '@progress/kendo-react-inputs';
import React from 'react';
import { FieldRenderProps } from '@progress/kendo-react-form';
import { GearFieldWrapper } from '../GearFieldWrapper';

interface FormNumberInputProps extends FieldRenderProps {
  isInteger: boolean;
}

const DECIMAL_PLACES_LIMIT = 6;

export const FormNumberInput: React.FC<FormNumberInputProps> = fieldRenderProps => {
  const { value, onChange, required, min, max, isInteger, disabled } = fieldRenderProps;
  return (
    <GearFieldWrapper {...fieldRenderProps}>
      <Input
        label={undefined}
        value={value}
        onChange={e => {
          const newValue = e.target.value as string;
          if (isInteger) {
            if (/^-?\d*$/.test(newValue)) {
              onChange(e);
            }
          } else {
            const decimalRegex = new RegExp(`^-?\\d*(\\.\\d{0,${DECIMAL_PLACES_LIMIT}})?$`);
            if (decimalRegex.test(newValue)) {
              onChange(e);
            }
          }
        }}
        type="number"
        required={required}
        min={min}
        max={max}
        step={isInteger ? 1 : Math.pow(10, -DECIMAL_PLACES_LIMIT)}
        disabled={disabled}
      />
    </GearFieldWrapper>
  );
};
